module.exports = __webpack_public_path__ + "img/DeepeningCategoryScreenshot-1250h.dca692a5.png";